module.exports = __webpack_public_path__ + "img/post2.db688377.png";